import {inject, Injectable} from '@angular/core';
import {HypothesisFilesApiService} from "./hypothesis-files-api.service";
import {AttachHypothesisFileParams, HypothesisFilesData} from "../types/hypothesis-modal.types";
import {FileParams, FileTypeName, HypothesisFileTypeName, UpdateFieldCommentFile} from "../../../../types/file.types";
import {HypothesisFilesStateService} from "./hypothesis-files-state.service";
import {PreviewFileUrlsStateService} from "../../../../services/preview-file-urls-state.service";

@Injectable({
  providedIn: 'root'
})
export class HypothesisFilesService {
  private hypothesisFilesApiService: HypothesisFilesApiService = inject(HypothesisFilesApiService);
  private hypothesisFilesStateService: HypothesisFilesStateService = inject(HypothesisFilesStateService);
  private previewFileUrlsStateService: PreviewFileUrlsStateService = inject(PreviewFileUrlsStateService);

  public getFileUrls() {
    const filesState = this.hypothesisFilesStateService.hypothesisFilesState();
    if (!filesState) return;

    const filesByType = Object.entries(filesState).reduce((acc, [fileType, filesArray]) => {
      const type = fileType as HypothesisFileTypeName;
      acc[type] = filesArray.map(item => item.file);
      return acc;
    }, {} as Record<FileTypeName, FileParams[]>);

    this.previewFileUrlsStateService.setPreviewFileUrlsState(filesByType);
  }

  public getHypothesisFiles(hypothesisId: number): Promise<Array<HypothesisFilesData>> {
    return new Promise((resolve, reject) => {
      this.hypothesisFilesApiService.getHypothesisFiles(hypothesisId).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachHypothesisFile(attachHypothesisFileParams: AttachHypothesisFileParams): Promise<HypothesisFilesData> {
    return new Promise((resolve, reject) => {
      this.hypothesisFilesApiService.attachHypothesisFile(attachHypothesisFileParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updateCommentHypothesisFile(updateFieldCommentFile: UpdateFieldCommentFile): Promise<HypothesisFilesData> {
    return new Promise((resolve, reject) => {
      this.hypothesisFilesApiService.updateCommentHypothesisFile(updateFieldCommentFile).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteHypothesisFile(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.hypothesisFilesApiService.deleteHypothesisFile(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
